export default "__VITE_ASSET__DTxQQp_W__"